/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA sequence`)
};

const es_gcskew_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secuencia de ADN`)
};

const de_gcskew_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA-Sequenz`)
};

const nl_gcskew_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA-sequentie`)
};

const fr_gcskew_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séquence ADN`)
};

const it_gcskew_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequenza DNA`)
};

const pt_br2_gcskew_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequência de DNA`)
};

const pt_gcskew_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequência de ADN`)
};

const ja_gcskew_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA配列`)
};

const zh_gcskew_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA 序列`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_input_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_input_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_input_label", locale)
	if (locale === "en") return en_gcskew_input_label(inputs)
	if (locale === "es") return es_gcskew_input_label(inputs)
	if (locale === "de") return de_gcskew_input_label(inputs)
	if (locale === "nl") return nl_gcskew_input_label(inputs)
	if (locale === "fr") return fr_gcskew_input_label(inputs)
	if (locale === "it") return it_gcskew_input_label(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_input_label(inputs)
	if (locale === "pt") return pt_gcskew_input_label(inputs)
	if (locale === "ja") return ja_gcskew_input_label(inputs)
	return zh_gcskew_input_label(inputs)
};